import { useSampleSli360Report } from "./sample-sli-360.context";
import { AveragesVotesChart } from "@/src/components/charts/averages-votes-chart/averages-votes-chart";

export const SampleSli360StrenghtsImprovementPage: React.FC<
  Record<string, never>
> = () => {
  const report = useSampleSli360Report();
  return <AveragesVotesChart pillarSummaryPage={report.pillarSummaryPage} />;
};
